<template>
    <nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-primary" aria-label="Main navigation">
        <div class="container-fluid">
            <RouterLink to="/" class="navbar-brand">
                <Logo class="logo" />
            </RouterLink>
            <button class="navbar-toggler p-0 border-0" type="button" id="navbarSideCollapse"
                aria-label="Toggle navigation" @click="toggleMenu">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="navbar-collapse offcanvas-collapse" :class="{ open: show_menu }">
                <Menu />
                <button class="btn text-white" @click="auth.logout">Sair</button>
            </div>
        </div>
    </nav>

</template>
<script setup lang="ts">

import Logo from '@/assets/logo.svg?component'
import Menu from './Menu.vue'
import { useAuth } from '@/plugins/auth';
import { ref } from 'vue';

const auth = useAuth()
const show_menu = ref<boolean>(false)


const toggleMenu = () => {
    show_menu.value = !show_menu.value
}

</script>
<style lang="less" scoped>

@media (max-width: 991.98px) {
    .offcanvas-collapse {
        position: fixed;
        top: 56px;
        /* Height of navbar */
        bottom: 0;
        left: 100%;
        width: 100%;
        padding-right: 1rem;
        padding-left: 1rem;
        overflow-y: auto;
        visibility: hidden;
        background-color: #343a40;
        transition: transform 0.3s ease-in-out, visibility 0.3s ease-in-out;

        &.open {
            visibility: visible;
            transform: translateX(-100%);
        }
    }

}

</style>